function escapeCsvValue(value) {
  if (value === null || value === undefined) {
    return "";
  }

  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
}

export function getMovimientosForRange(movimientos = [], fechaInicio = "", fechaFin = "") {
  return movimientos.filter((movimiento) => {
    const fecha = movimiento?.fecha || "";
    const dentroDesde = !fechaInicio || fecha >= fechaInicio;
    const dentroHasta = !fechaFin || fecha <= fechaFin;
    return dentroDesde && dentroHasta;
  });
}

export function buildReporteCsvContent({ rango, reporte, movimientos = [] }) {
  const movimientosFiltrados = getMovimientosForRange(
    movimientos,
    rango?.fechaInicio || "",
    rango?.fechaFin || "",
  );

  const filas = [
    ["KPI", "Valor"],
    ["Fecha inicio", rango?.fechaInicio || ""],
    ["Fecha fin", rango?.fechaFin || ""],
    ["Total reservas", reporte?.total_reservas || 0],
    ["Reservas pagadas", reporte?.reservas_pagadas || 0],
    ["Reservas pendientes", reporte?.reservas_pendientes || 0],
    ["Reservas canceladas", reporte?.reservas_canceladas || 0],
    ["Ingresos", reporte?.ingresos || 0],
    ["Egresos", reporte?.egresos || 0],
    ["Saldo", reporte?.saldo || 0],
    [],
    ["Cancha", "Reservas", "Pagadas", "Pendientes", "Canceladas", "Facturado"],
    ...((reporte?.desglose_por_cancha || []).map((item) => [
      item.cancha,
      item.reservas,
      item.pagadas,
      item.pendientes,
      item.canceladas,
      item.facturado,
    ])),
    [],
    ["Movimientos de caja (detalle)", "", "", "", ""],
    ["Tipo", "Concepto", "Monto", "Fecha", "Reserva ID"],
    ...(movimientosFiltrados.length > 0
      ? movimientosFiltrados.map((movimiento) => [
          movimiento.tipo,
          movimiento.concepto,
          Number(movimiento.monto || 0).toFixed(2),
          movimiento.fecha || "",
          movimiento.reserva_id ?? "",
        ])
      : [["Sin movimientos", "", "", "", ""]]),
  ];

  return filas
    .map((fila) => fila.map(escapeCsvValue).join(","))
    .join("\n");
}
